import { render, staticRenderFns } from "./competitiveChannels.vue?vue&type=template&id=599c8672&scoped=true"
import script from "./competitiveChannels.vue?vue&type=script&lang=js"
export * from "./competitiveChannels.vue?vue&type=script&lang=js"
import style0 from "./competitiveChannels.vue?vue&type=style&index=0&id=599c8672&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "599c8672",
  null
  
)

export default component.exports